<template>
    <form id="paymentDetails">
        <h2 id="paymentDetailsHead">Contribution Details</h2>
        <p class="paymentSubhead">Please consider increasing your contribution. Every dollar supports Native communities to preserve traditional lands.</p>
        <p class="paymentSubhead">Minimum: $0, Suggested Contribution Amount: ${{payment_recommended.toFixed(2)}}.</p>
        <!--            <label for="recurring"><input type="checkbox" id="recurring" v-model="recurring"> Set up recurring-->
        <!--                payment</label>-->
        <div v-if="!this.recurring" id="notRecurring">
            <label for="paymentTotal" id="paymentTotalWrap"><input class="dark" type="number" :min="payment_min" @blur="setPaymentAmount" v-model="payment_value" id="paymentTotal"></label>
        </div>
        <div v-if="this.recurring">Need to figure out how setting up a recurring payment with PayPal works.</div>
        <div id="userDetails">
            <label for="fName"><input class="dark" type="text" id="fName" v-model="fName" @change="checkValidation" ref="fName" placeholder="First Name" required></label>
            <label for="lName"><input class="dark" type="text" id="lName" v-model="lName" @change="checkValidation" ref="lName" placeholder="Last Name" required></label>
            <label for="email" id="emailLabel"><input class="dark" type="email" id="email" v-model="email" @change="checkValidation" ref="email" placeholder="Email Address" required></label>
        </div>
        <label for="anonymous" id="anonymousWrap"><input type="checkbox" id="anonymous" v-model="anonymous"> Contribute anonymously</label>
        <div id="paymentButton">
            <div id="formInvalid" v-if="!valid_form">
                <p>Please fill out the form above to continue to checkout.</p>
            </div>
            <PayPal
                :amount="this.payment_value.toString()"
                currency="USD"
                :client="credentials"
                env="production"
                :button-style="this.paypalStyle"
                :items="paypalItems"
                @payment-completed="paymentCompleted"
                @payment-cancelled="paymentCancelled"></PayPal>
            <div id="payError" v-if="showError">An error was encountered during payment. Please try again later.</div>
            <div id="paypalDisclaimer">No account required. All major credit cards accepted.</div>
            <!--                <button @click="testPay">Test sending contribution to server</button>-->
        </div>
    </form>
</template>

<script>
    import PayPal from "vue-paypal-checkout";
    export default {
        name: "PaymentBox",
        components: {PayPal},
        data() {
            return {
                showError: false,
                fName: "",
                lName: "",
                email: "",
                valid_form: false,
                recurring: false,
                anonymous: false,
                payment_min: 0,
                payment_recommended: 25,
                payment_value: 0,
                default_min: 0, // Payment will never be able to be lower than this.
                default_recommended: 25,
                credentials: {
                    sandbox: "AQQFd9IC6APOKL2bFjAOIvHrQL7GuTy56aXUi4UzpMxqhyhE0jnuvgbnb5h-sGtICnw7YwlzKuEmIOzA",
                    production: "AVpfVc-igcw4Cl7Kh5r4fmTSS0MfvHARuTxWjocy64R8rUYYyH-e8Ttksk7y7TCK68hK78NL2lmGoU22"
                },
                paypalStyle: {
                    label: 'checkout',
                    size: 'responsive',          // small | medium | large | responsive
                    shape: 'rect',         // pill | rect
                    color: 'blue'         // gold | blue | silver | black
                }
            };
        },
        computed: {
            paypalItems() {
                return [
                    {
                        name: "TICO2E Donation",
                        quantity: 1,
                        currency: "USD",
                        price: this.payment_value ? this.payment_value.toString() : "0"
                    }
                ];
            }
        },
        mounted() {
            this.setup();
        },
        methods: {
            async setup() {
                this.showError = false;
                this.payment_value = this.payment;
                if (await this.$auth.isAuthenticated() && this.$store.getters["user/isSet"]) {
                    this.fName = await this.$store.getters["user/getItem"]("first_name");
                    this.lName = await this.$store.getters["user/getItem"]("last_name");
                    this.email = await this.$store.getters["user/getItem"]("preferred_username");
                }
                this.setPaymentRecommended();
                if (this.payment_value < this.payment_recommended) {
                    this.payment_value = this.payment_recommended;
                }
                this.setPaymentAmount();
                this.checkValidation();
            },
            // setPaymentMin() {
            //     this.payment_min = Math.max(this.payment_value.toFixed(2), this.default_min);
            // },
            setPaymentRecommended() {
                this.payment_recommended = Math.max(this.payment_value, this.default_recommended);
            },
            paymentCompleted(e) {
                if (e.state !== "approved") {
                    this.showError = true;
                    return;
                }
                this.callback(e, this.fName, this.lName, this.email, this.anonymous);
            },
            paymentCancelled(e) {
                console.log("Payment canceled. Object returned:");
                console.log(e);
            },
            setPaymentAmount() {
                if (typeof this.payment_value !== "number") {
                    this.payment_value = Number.parseFloat(this.payment_value);
                }
                this.payment_value = this.payment_value.toFixed(2);
                this.clampPayment();
            },
            clampPayment() {
                if (this.payment_value < this.payment_min) {
                    this.payment_value = this.payment_min;
                }
            },
            checkValidation() {
                // Wait until next frame so the validity gets updated.
                this.$nextTick(() => {
                    let fNameValid = typeof this.fName === "string" && this.fName !== "";
                    let lNameValid = typeof this.lName === "string" && this.lName !== "";
                    let emailValid = typeof this.email === "string" && this.email !== "" && this.email.indexOf("@") > 0;
                    this.valid_form = fNameValid && lNameValid && emailValid;
                });
            }
        },
        props: ["payment", "callback"]
    };
</script>

<style scoped lang="less">
    @import (reference) "../assets/variables";
    #paymentTotalWrap {
        position: relative;
        min-width: 48%;
        font-size: 2.5rem;
        &:before {
            content: "$";
            font-family: "Lora", serif;
            position: absolute;
            left: 0;
            top: -0.1em;
        }
    }

    #paymentTotal {
        font-size: 2.5rem;
        padding: 0 0 0 0.65em;
        font-family: "Lora", serif;
    }
    #paymentDetails{
        background: @green;
        color: white;
        padding: 2em 1.5em 1.5em;
        border-radius: 1em;
    }

    #paymentDetailsHead{
        font-size: 2rem;
        margin: 0;
        text-align: left;
    }

    .paymentSubhead{
        margin: 0.5em 0;
        text-align: left;
        font-size: 0.9rem;
    }

    #userDetails{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        label{
            width: 48%;
            margin-bottom: 0.5rem;
        }
        input{
            width: 100%;
        }
        #emailLabel{
            margin-top: 0.5rem;
            min-width: 100%;
        }
    }
    #anonymousWrap{
        display: block;
        margin: 1.5rem 0;
        text-align: left;
        input[type=checkbox]{
            transform: scale(1.5);
        }
    }
    #formInvalid{
        color: @text-color;
        background: rgba(255, 255, 255, 0.9);
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 150;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
    }
    #paymentButton {
        display: inline-block;
        position: relative;
        font-size: 24px;
        margin: 0.5em 0;
        background: white;
        padding: 1em 1em 0.33em;
        width: 335px;
        max-width: 78%;
        border-radius: 0.5em;
    }
    #paypalDisclaimer{
        margin: 0.25em 1em 0;
        font-size: 0.75rem;
        color: @text-color;
    }
    #payError{
        color: @red;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/PaymentBox.vue